import React from 'react';
import * as messages from '@radnuc/messages';
import {setConfig} from './Config';
import { AuthenticationInterface } from './AuthenticationDisplay';

import './DoseRateAlarmThresholdDisplay.css'
//import { defaultDoseRateAlarmThresh } from '../system-configuration';

export interface DoseRateAlarmThresholdDisplayProps {
    config?: messages.ConfigurationState.InvestigationConfig
    authenticationInterface?: AuthenticationInterface
    defaultDoseRateAlarmThresh? : number
    useDoseRateSIUnit?: boolean
}

export interface DoseRateAlarmThresholdDisplayDisplayState {
    goalConfig?: messages.ConfigurationState.InvestigationConfig
    dose_rate_input_value: string
}

export class DoseRateAlarmThresholdDisplay extends React.Component<DoseRateAlarmThresholdDisplayProps,
        DoseRateAlarmThresholdDisplayDisplayState, {}> {
    timeoutTimer: NodeJS.Timeout | null;
    editing: boolean = false;
    dose_rate_value_displayed:string = '???';
    threshold_off_value: number = 9999998;
    input_last_changed:number = 0;
    dose_rate_conversion:number = 1;

    constructor(props: DoseRateAlarmThresholdDisplayProps) {
        super(props)
        this.state = { dose_rate_input_value:'???' }
        this.timeoutTimer = null;

        this.handlePasswordInputKeyPress = this.handlePasswordInputKeyPress.bind(this);
        this.setDoseRateAlarmThreshold = this.setDoseRateAlarmThreshold.bind(this);
        this.handleOnSetClick = this.handleOnSetClick.bind(this);
        this.handleOffClick = this.handleOffClick.bind(this);
    }
    componentDidMount(){
        if(this.props.useDoseRateSIUnit===true){
            this.dose_rate_conversion = 0.01;
        } else {
            this.dose_rate_conversion = 1;
        }
    }

    componentDidUpdate(prevProps: DoseRateAlarmThresholdDisplayProps){
        if(this.props.useDoseRateSIUnit !== prevProps.useDoseRateSIUnit){
            if(this.props.useDoseRateSIUnit===true) {
                this.dose_rate_conversion = 0.01;
            } else {
                this.dose_rate_conversion = 1;
            }
        }
        if(this.props.config?.dose_alarm_threshold !== undefined && this.props.config?.dose_alarm_threshold !== null){
            if(this.props.config.dose_alarm_threshold < this.threshold_off_value
                 && this.state.dose_rate_input_value !== (this.props.config.dose_alarm_threshold*this.dose_rate_conversion).toFixed(0)){
                if(!this.editing){
                    if(this.props.config.dose_alarm_threshold < this.threshold_off_value){
                        this.setState({dose_rate_input_value: (this.props.config.dose_alarm_threshold*this.dose_rate_conversion).toFixed(0)})
                    } else {
                        this.setState({dose_rate_input_value: (this.getDefaultDoseRateAlarmThresh()*this.dose_rate_conversion).toFixed(0)})
                    }
                }
            }
            if(prevProps.config?.dose_alarm_threshold !== undefined && this.props.config?.dose_alarm_threshold !== null){
                if(this.props.config.dose_alarm_threshold !== prevProps.config.dose_alarm_threshold){
                    this.setState({dose_rate_input_value: (this.props.config.dose_alarm_threshold*this.dose_rate_conversion).toFixed(0)})
                }
            }
        } else {
            if(!this.editing){
                //Dose alarm setting is unknown
                if(this.state.dose_rate_input_value !== '???')
                    this.setState({dose_rate_input_value: '???'})
            }
        }
    }

    getDefaultDoseRateAlarmThresh(){
        let defaultDoseRateAlarmThresh;
        if (this.props.defaultDoseRateAlarmThresh === undefined){
            defaultDoseRateAlarmThresh = 2000;
        } else {
            defaultDoseRateAlarmThresh = this.props.defaultDoseRateAlarmThresh;
        }
        return defaultDoseRateAlarmThresh;
    }

    async setDoseRateAlarmThreshold(value: number){
        //console.log('Set dose rate alarm threshold: ' + value);

        let config = new messages.ConfigurationState.InvestigationConfig();
        config.dose_alarm_threshold = value;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.INVESTIGATION;
        message.inv = config;

        await setConfig(message);
    }

    handleOnSetClick(){
        if(this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        this.timeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, 10000);
        this.checkDoseAlarmThreshold();
        if(this.props.authenticationInterface){
            this.props.authenticationInterface.authenticate(()=>this.setDoseAlarmThreshold());
        } else {
            this.setDoseAlarmThreshold();
        }
    }

    handleOffClick(){
        if(this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        this.timeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, 10000);
        if(this.props.authenticationInterface){
            this.props.authenticationInterface.authenticate(()=>this.setDoseAlarmOff());
        } else {
            this.setDoseAlarmOff();
        }
    }

    checkDoseAlarmThreshold(){
        let inputval = parseInt(this.state.dose_rate_input_value);
        if(isNaN(inputval) || inputval === this.threshold_off_value*this.dose_rate_conversion){
            inputval = this.getDefaultDoseRateAlarmThresh()*this.dose_rate_conversion;
        }
        this.setState({
            dose_rate_input_value: inputval.toFixed(0)
        })
    }

    async setDoseAlarmThreshold(){
        let value = parseFloat(this.state.dose_rate_input_value);
        if (this.props.useDoseRateSIUnit === true){
            //N.B. Backend values are always in uR/hr
            value = value * 100;
        }
        if( value >= this.threshold_off_value){
            console.log('Max Dose Rate Threshold reached. Setting to just below OFF value uR/hr')
            value = this.threshold_off_value-1;
        }

        await this.setDoseRateAlarmThreshold(value);
    }

    async setDoseAlarmOff(){
        await this.setDoseRateAlarmThreshold(this.threshold_off_value);
    }

    handlePasswordInputKeyPress(event:React.KeyboardEvent){
        var code = event.keyCode || event.which;
        if(code === 13) { //13 is the enter keycode
            //console.log('return pressed')
            this.checkDoseAlarmThreshold();
            this.handleOnSetClick();

            event.preventDefault();
        }
    }
    updateInput(event:React.ChangeEvent<HTMLInputElement>){
        let value = event.currentTarget.value;
        if (/\D/g.test(value)){
            value = value.replace(/[^\d\.]/g,'');
        }
        this.input_last_changed = new Date().getTime();
        if(this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        this.timeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, 10000);

        this.setState({ dose_rate_input_value: value })

    }

    setEditTimeout(){
        if(this.props.config){
            this.editing = false;
            if(this.props.config.dose_alarm_threshold !== undefined && this.props.config.dose_alarm_threshold !== null){
                if(!this.isAuthenticationDisplayShowing()){
                    this.setState({ dose_rate_input_value: this.props.config.dose_alarm_threshold.toFixed(0) });
                } else {
                    //Authentication Window Showing so reset
                    this.resetEditTimeout();
                }
            } else {
                if(!this.isAuthenticationDisplayShowing()){
                //Setting UNKNOWN
                    if(this.state.dose_rate_input_value !== '???')
                        this.setState({dose_rate_input_value: '???'});
                } else {
                    //Authentication Window Showing so reset
                    this.resetEditTimeout();
                }
            }
        } else {
            if(!this.isAuthenticationDisplayShowing()){
                //Setting UNKNOWN
                if(this.state.dose_rate_input_value !== '???')
                    this.setState({dose_rate_input_value: '???'})
            } else {
                //Authentication Window Showing so reset
                this.resetEditTimeout();
            }
        }
    }

    resetEditTimeout(){
        this.timeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, 10000);
    }

    setEditing(flag:boolean){
        if(flag){
            this.editing = true;
        } else {
            this.editing = false;
            if(this.timeoutTimer !== null) {
                clearTimeout(this.timeoutTimer);
            }
        }
    }

    isAuthenticationDisplayShowing(){
        const authenticationWindow= document.getElementById('authentication-container');
        if (authenticationWindow !== null) {
            return true;
        } else {
            return false;
        }
    }

    render(){

        let onSetClass;
        let offClass;

        if(this.props.config?.dose_alarm_threshold){
            if (this.props.config?.dose_alarm_threshold >= this.threshold_off_value) {
                offClass = 'selected';
            } else if (this.props.config?.dose_alarm_threshold > 0 ) {
                onSetClass = 'selected';
            }
        }

        let doseRateAlarmThreshClass = '';

        if(this.state.dose_rate_input_value !== '???'){
            if(parseInt(this.state.dose_rate_input_value) !== Math.round(this.props.config?.dose_alarm_threshold!)*this.dose_rate_conversion){
                if(offClass==='selected'){
                    this.setEditing(false);
                } else {
                    this.setEditing(true);
                    doseRateAlarmThreshClass = ' changed';
                }
            } else {
                this.setEditing(false);
            }
        } else {
            this.setEditing(false);
        }


        let input_field;
        if(offClass==='selected'){
            input_field =  <input type="thresh" id="dose-rate-alarm-thresh-input" className={doseRateAlarmThreshClass} name="thresh" autoComplete='off'
                value='OFF' required placeholder=" "/>
        } else {
            input_field =  <input type="thresh" id="dose-rate-alarm-thresh-input" className={doseRateAlarmThreshClass} name="thresh" autoComplete='off'
                value={this.state.dose_rate_input_value} onChange={(e)=>this.updateInput(e)} onKeyPress={this.handlePasswordInputKeyPress} required placeholder=" "/>
        }
        let dose_rate_unit_string = '\u00B5R/hr'
        if (this.props.useDoseRateSIUnit === true){
            dose_rate_unit_string = '\u00B5Sv/hr'
        }

        return(

            <div style={{display:'flex', flex:'1 1 0%', flexDirection:'row', justifyContent:'space-between'}}>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <label className="status-metric-title" style={{width:'90px',whiteSpace:'normal'}}>Dose Rate Alarm</label>
                    <div style={{display:'flex', flexDirection:'column', padding:'0px', margin:'0px', width:'90px'}}>
                    <form id="dose-rate-alarm-thresh" action="#0">
                        <div>
                            {input_field}
                        </div>
                        </form>
                    <label id="dose-rate-alarm-thresh-units" className="units" style={{textAlign:'center'}}>{dose_rate_unit_string}</label>
                    </div>
                </div>
                <div style={{display:'flex', flexDirection:'row', alignSelf:'center'}}>
                    <div id="expert-menu-dose-rate-alarm-on-set" className={"round-skinny-button "+onSetClass} onClick={this.handleOnSetClick}>On/Set</div>
                    <div id="expert-menu-dose-rate-alarm-off" className={"round-skinny-button "+offClass} onClick={this.handleOffClick}>Off</div>
                </div>
            </div>

        )
    }
}
export default DoseRateAlarmThresholdDisplay
